// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1qeg1","modal":"Modal_modal__3pxYq"};